import * as types from '../../action-types';
import { getCycles as initialState } from '../initialStates';

const getCycles = (state = initialState, action) => {
    const { payload, type } = action;

    switch (type) {
        case types.GET_CYCLES_START:
            return {
                ...state,
                isLoading: true,
            }
        case types.GET_CYCLES_SUCCESS:
            return {
                ...state,
                isSuccessful: true,
                data: payload,
            }
        case types.GET_CYCLES_FAIL:
            return {
                ...state,
                error: payload
            }
        case types.GET_CYCLES_CLEANUP:
            return {
                ...state,
                error: null,
                isSuccessful: false
            }
        default:
            return state;
    };
};

export default getCycles;

